const typePatern = {
  phone: /\([0-9]{2}\) [0-9]{4,7}-[0-9]{4,5}$/,
  email: /[@!#$%^&*-_()/\\a-zA-Z0-9]+[\.]?[@!#$%^&*-_()/\\a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-zA-Z0-9]{2,20}[\.][a-zA-Z0-9]{2,5}/g,
  ip: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
  number: /[0-9]+$/,
  senhas: {
    especial: `/^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]{1,20}$/`,
    maiuscula: `/^(?=.*[A-Z])[@!#$%^&*()/\\a-zA-Z0-9]{1,20}$/`
  }
}

export const validacaoCampo = ({ valor, name, pattern }) => {
  if (pattern?.search('type') !== -1) {
    pattern = JSON.parse(pattern)
  }
  
  
  if (typeof valor === 'object' && pattern === 'select') {
    if (valor && Object.keys(valor).length === 0 ) {
      return { name: name, message: 'empty' }
    } else {
      return { name: name, message: false }
    }
  } else if (valor && typeof valor === 'object' && pattern === 'multiselect') {
    if (valor.length === 0 ) {
      return { name: name, message: 'empty' }
    } else {
      return { name: name, message: false }
    }
  } else if (valor === undefined || valor === '') {
    return { name: name, message: 'empty' }
  } else if (typeof valor === 'boolean' && pattern === 'boolean') {
    return { name: name, message: valor ? true : false }
  }
  
  if ( typeof pattern === 'object' && pattern.type === 'number' ) {
    return {name: name, message: validarNumber({ valor, max: pattern.max, min: pattern.min })}
  } else if ( typeof pattern === 'object' && pattern.type === 'date' ) {
    return {name: name, message: validarData({ valor, max: pattern.max, min: pattern.min })}
  } else if ( typeof pattern === 'string' && pattern === 'cpf' ) {
    return {name: name, message: validarCPF(valor)}
  } else if ( typeof pattern === 'string' && pattern === 'senha' ) {
    return {name: name, message: validarSenha(valor)}
  } else if (valor?.search(typePatern[pattern] ? typePatern[pattern] : pattern) === -1) {
    return {name: name, message: 'regex'}
  } else {
    return {name: name, message: false}
  }
}

export const validarCampo = e => {
  const valor = e.value
  const { name, pattern } = e
  if (!valor) {
    return { name: name, message: 'empty' }
  }
  return validacaoCampo({ valor, name, pattern })
}

export const validacaoForm = e => {
  let erro = {}

  const pattern = e => {
    if (typeof e === 'object') {
      return JSON.stringify(e)
    } else if (typeof e === 'string') {
      return e
    } else {
      return ''
    }
  }

  for (const name in e.formRequired) {
    if (e.formRequired[name]) {
      let valForm = validacaoCampo({ valor: e.formValues[name], name, pattern: pattern( e.formRequired[name] ) })
      erro = { ...erro, [name]: valForm.message }
    } else {
      erro = { ...erro, [name]: !e.formValues[name] }
    }
  }
  return erro
}
export const verificaValidacao = (valor) => {
  const verify = Object.keys(valor).filter(e=> valor[e] !== false )
  return {list: verify, value: verify.length?false:true}
}

export const validarSenha = (valor) => {
  if (!valor) {
    return 'empty'
  }
  const valid = passwordStrengthValidator(valor)
  if (valid) {
    return valid==='strong'?false:valid
  }
  return false
}

export const validarSenhaConfirmar = ({value, senha}) => {
  if (!value) {
    return 'empty'
  }
  if (value !== senha) {
    return 'different'
  }
  return false
}

export const validarCPF = (e) =>{
  if (typeof e !== "string") return 'invalid'
  e = e.replace(/[\s.-]*/igm, '')
  if (
      !e ||
      e.length !== 11 ||
      e === "00000000000" ||
      e === "11111111111" ||
      e === "22222222222" ||
      e === "33333333333" ||
      e === "44444444444" ||
      e === "55555555555" ||
      e === "66666666666" ||
      e === "77777777777" ||
      e === "88888888888" ||
      e === "99999999999" 
  ) {
      return 'invalid'
  }
  var soma = 0
  var resto
  for (var i = 1; i <= 9; i++) 
      soma = soma + parseInt(e.substring(i-1, i)) * (11 - i)
  resto = (soma * 10) % 11
  if ((resto === 10) || (resto === 11)) resto = 0
  if (resto !== parseInt(e.substring(9, 10)) ) return 'invalid'
  soma = 0
  for (var n = 1; n <= 10; n++)
    soma = soma + parseInt(e.substring(n-1, n)) * (12 - n)
  resto = (soma * 10) % 11
  if ((resto === 10) || (resto === 11)) resto = 0
  if (resto !== parseInt(e.substring(10, 11) ) ) return 'invalid'
  return false
}

export const validarData = (e) =>{
  const dmin = new Date(e.min);
  const dmax = new Date(e.max);
  const de = new Date(e.valor);
  if(de < dmin) return 'less';
  if(de > dmax) return 'larger';
  return false;
}

export const validarNumber = (e) =>{
  if( Number(e.valor) < Number(e.min) ) return 'less';
  if( Number(e.valor) > Number(e.max) ) return 'larger';
  return false;
}

const matches = {
  weak: /(?=.*[a-z])/, //letra minuscula
  medium: /((?=.*[a-z])|(?=.*[A-Z]))(?=.*\d).{6,}/, //minuscula e/ou maiuscula com numero, até 7 ou mais
  okay: /((?=.*[a-z])|(?=.*[A-Z]))(?=.*\d).{6,}/, //minuscula e/ou maiuscula com numero, com 8 ou mais
  strong: /((?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)).{6,}/ //acima de oito com caracter especial e todo o resto acima
};
export const passwordStrengthValidator = password => {
  // return password.length >= 6 ? false : 'min'
  var strengthLevel = 'weak';
  for (var matchKey in matches) {
    if (matches[matchKey].test(password)) strengthLevel = matchKey;
  }
  return strengthLevel;
};

export const passwordHasOk = /((?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)).{6,}/


export const itens = [
  {
    label: '*Conter letra maiúscula',
    has: /[A-Z]/,
  },
  {
    label: '*Conter número',
    has: /[0-9]/,
    //has: /[0-9]+$/,
  },
  {
    label: '*Conter caractere especial',
    has: /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]{1,20}$/,
  },
  {
    label: '*Conter 6 ou mais caracteres',
    has: /.{6,}/,
  }
]
export const passwordHas = (senha, nls) => {
  console.error(senha, 'passwordHaspasswordHaspasswordHaspasswordHas');

  // Definir regras de senha usando o nls para tradução dinâmica
  const itens = [
    {
      label: nls.senha.maiuscula, // Tradução dinâmica
      has: /[A-Z]/,
    },
    {
      label: nls.senha.numero, // Tradução dinâmica
      has: /[0-9]/,
    },
    {
      label: nls.senha.caractereEspecial, // Tradução dinâmica
      has: /^(?=.*[@!#$%^&*()/\\])[@!#$%^&*()/\\a-zA-Z0-9]{1,20}$/,
    },
    {
      label: nls.senha.tamanhoMinimo, // Tradução dinâmica
      has: /.{6,}/,
    }
  ];
  
  let resp = ''
  itens.forEach(e => {
    resp += `<label class=${e.has.test(senha) ? 'has-success' : ''}>${e.label}</label>`
  });
  return resp;
};